// @vendors
import { useMemo, useState } from 'react'

// @context
import { useUI } from '../../../app/context/ui';

// @services
import FileService from '../../../services/newApi/FileService';

// @helpers
import AppHelper from '../../../helpers/AppHelper';

const UseFile = () => {
    const [categories, setCategories] = useState([]);
    const fileService = useMemo(() => new FileService(), []);
    const { blockUI, snackbarUI } = useUI();

    const [rowsState, setRowsState] = useState({
        pageSize: 10,
        rows: [],
        rowCount: 0,
        currentPage: 0,
        page: 0,
    });

    const [filter, setFilter] = useState({
        category: "",
        createdAt: null,
        errorStatus: null
    });

    const fetchCategories = async () => {
        try {
            const response = await fileService.getCategories();
            setCategories(response?.data?.data);
        } catch (error) {
            AppHelper.checkError(error, snackbarUI); 
        }
    }

    const fetchFiles = async (params) => {
        const paramsService = {
            pagination: {page: params?.page ?? 1, size: params?.size ?? rowsState.pageSize},
            filters: params?.filters ?? {},
        }
        try {
          blockUI.current.open(true);
          const response = await fileService.getFiles(paramsService);
          successRequestFiles(response);
          blockUI.current.open(false);
        } catch (error) {
          blockUI.current.open(false);
          AppHelper.checkError(error, snackbarUI);
        }
    }

    const successRequestFiles = (response) => {
        const data = response?.data;
        setRowsState((prev) => ({
          ...prev,
          pageSize: data?.pagination?.page_size || 10,
          rows: data?.data || [],
          rowCount: data?.pagination?.total_records || 0,
          currentPage: data?.pagination?.page_number,
          page: data?.pagination?.page_number -1,
        }));
    }
  
    return {
        categories,
        rowsState,
        setRowsState,
        fetchCategories,
        fetchFiles,
        filter,
        setFilter
    }
}

export default UseFile